/* eslint-disable max-len */
import { useState } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import SignUp from './components/SignUp';
import Login from './components/Login';
import ForgotPassword from './components/ForgotPassword';
import VerifyOTP from './components/VerifyOTP';
import UserDetails from './components/UserDetails';
import PricingPlans from './components/PricingPlans';
// import Checkout from './components/Checkout';
// import EnterpriseContact from './components/EnterpriseContact';
import EnterpriseContact from './components/EnterpriseContact';
import ProtectedRoute from './ProtectedRoute';
import ProtectedRouteMain from './ProtectedRouteMain';
import GoogleSignupCallback from './components/GoogleSignupCallback';
import GoogleLoginCallback from './components/GoogleLoginCallback';
import McpLogin from './components/McpLogin';

function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<ProtectedRouteMain element={<Login />} />} />
        <Route path="/mcp-login" element={<McpLogin />} />
        <Route path="/signup" element={<ProtectedRouteMain element={<SignUp />} />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/verify" element={<VerifyOTP />} />
        <Route path="/user-details" element={<ProtectedRoute element={<UserDetails />} />} />
        <Route path="/pricing-plans" element={<ProtectedRoute element={<PricingPlans />} />} />
        {/* <Route path="/checkout" element={<ProtectedRoute element={<Checkout />} />} />
        <Route path="/enterprise-contact" element={<ProtectedRoute element={<EnterpriseContact />} />} /> */}
        <Route path="/enterprise-contact" element={<EnterpriseContact />} />
        <Route path="/google-signup-connect" element={<GoogleSignupCallback />} />
        <Route path="/google-login-connect" element={<GoogleLoginCallback />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster
        position="top-center"
        reverseOrder={false}
      />
    </div>
  );
}

export default App;
